import classNames from "classnames";

export default {
  props: ["active", "handleClick", "activeClassName"],

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const activeClassName = this.activeClassName || "bg-brand-blue-500";

    const className = classNames(
      "w-full flex-1 m-1 mb-0 cursor-pointer rounded-t border border-brand-gray-800 border-b-0 p-1 lg:p-2 text-center text-white",
      this.active ? activeClassName : 'bg-brand-gray-500'
    );

    return (
      <div class={className} onClick={this.handleClick}>
        <div class="flex items-center h-full justify-center">
          { this.$slots.default }
        </div>
      </div>
    )
  }
}
